import $ from "jquery";

console.log('landing...')

function isNullOrUndef(value){
    let isNull = null === value
    let isUndefined = undefined === value
    let isUndefinedStr = 'undefined' === value
    let isNullStr = 'null' === value
    let isUndNullStr  = 'Undefined or Null' === value
    return isNull || isUndefined || isUndefinedStr || isNullStr || isUndNullStr
}

function setWarranty(){
    let checked = $('#warranty_fleet') && $('#warranty_fleet').prop('checked')
    if(checked) {
        $('#warranty_warranty').val($('#model_warranty_fleet').val())
    } else {
        $('#warranty_warranty').val($('#model_warranty').val())
    }
}

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}

async function getVehicleBatteries(vehicle_id) {
    try {
        // 1. Send the GET request (fetch uses GET by default)
        const response = await fetch('/landing/get/batteries/'+vehicle_id);

        // 2. Check if the HTTP status code is OK (200-299)
        if (!response.ok) {
            throw new Error(`HTTP error! getVehicleBatteries status: ${response.status}`);
        }

        // 3. Parse the JSON response data
        const data = await response.json();
        displayBatteryModels(data)
    } catch (error) {
        // 4. Handle network or parsing errors
        console.error('Fetch error:', error);
    }
}

function initVehicleSearch() {
    // Asegurar URL
    let searchUrl = $('.vehicle-ajax-search').data('url');

    // 500 milisegundos de retraso
    setTimeout(function() {

        let $select = $('.vehicle-ajax-search');

        // // Destruye cualquier instancia previa
        // if ($select.hasClass("select2-hidden-accessible")) {
        //     $select.select2('destroy');
        // }
        // // Desconecta cualquier evento fantasma
        // $select.off('select2:select');
        // // Limpia opciones HTML (Caché basura de Turbolinks)
        // $select.empty();


        $select.select2({
            placeholder: 'Escribe para buscar (ej. Nissan Versa 2018)...',
            allowClear: true,
            theme: "classic",
            width: 'resolve',
            minimumInputLength: 2,
            ajax: {
                url: searchUrl,
                dataType: 'json',
                delay: 250,
                data: function(params) {
                    return { q: params.term };
                },
                processResults: function(data) {
                    return { results: data.results };
                },
                cache: true
            }
        });

        $select.on('select2:select', function (e) {
            let data = e.params.data;
            getVehicleBatteries(data.id)
        });
        $select.on('select2:unselect', function (e) {
            let target = document.getElementById('bci-recomendado');
            if (target) {
                target.innerText = '';
            }
            let resultModels = document.getElementById('search-result-models')
            if (resultModels) {
                resultModels.innerHTML = ''
            }
            let searchResult = document.getElementById('battery-search-result')
            if(searchResult) {
                searchResult.style.display = "none";
            }
        });
    }, 500);
}

function displayBatteryModels(data) {
    // {"id":17303,"text":"2004 Chevrolet Chevy - 4Cil 1.6L","bcis":"99","batteries":[{"id":20,"batteries_brand_id":1,"batteries_bci_id":6,"name":"PREMIUM","battery_type":null,"list_price_iva":"3132.0","list_price":"2700.0","warranty":48,"volts":12,"plates":"","length":null,"width":null,"high":null,"weight":null,"c_a":null,"c_c_a":480,"reserve_capacity_min":null,"active":true,"created_at":"2025-11-30T14:27:47.043-06:00","updated_at":"2025-11-30T14:27:47.070-06:00","warranty_fleet":46,"batteries_supplier_id":4,"medium_photo_url":null,"description":"PONCE BATTERY 99 PREMIUM","warranty_months":"48 meses","price_iva":"$3,132.00","price":"$2,700.00","bci":"99"},{"id":15,"batteries_brand_id":1,"batteries_bci_id":6,"name":"CONMEMORATIVA","battery_type":null,"list_price_iva":"2262.0","list_price":"1950.0","warranty":18,"volts":12,"plates":"9","length":null,"width":null,"high":null,"weight":null,"c_a":null,"c_c_a":357,"reserve_capacity_min":"","active":true,"created_at":"2025-11-20T14:00:20.146-06:00","updated_at":"2026-06-01T19:43:14.906-06:00","warranty_fleet":9,"batteries_supplier_id":2,"medium_photo_url":null,"description":"PONCE BATTERY 99 CONMEMORATIVA","warranty_months":"18 meses","price_iva":"$2,262.00","price":"$1,950.00","bci":"99"}],"selected":true}


    // let engine_id = $('#vehicle_engines_id').val()
    // let str_products   = $('#data_products').val()
    // let products = JSON.parse(str_products)

    let searchResult = document.getElementById('battery-search-result')
    let target = document.getElementById('bci-recomendado')
    let resultModels = document.getElementById('search-result-models')
    // const result = products.find(
    //     product => product.engine_id === Number(engine_id)
    // );
    const result = data
    const models = data.batteries
    let modelsHtml = ''
    searchResult.style.display = "block";
    target.innerHTML = isNullOrUndef(result) || isNullOrUndef(result.bcis) ? 'No se encontraron resultados' : 'Nuestras baterías para BCI: ' + result.bcis
    resultModels.innerHTML = ''
    if(models && models[0]) {
        models.forEach(m => {
            let model = '<div class="col-lg-3 col-md-6">\n' +
                '          <div class="product-block-one week-deal-one">\n' +
                '            <div class="ribon fs_13">BCI '+m.bci+'</div>\n' +
                '            <div class="product-block-one-image">\n' +
                '              <div class="image">\n' +
                '                <img class="text-centered" style="width: 250px; height: 188px;" src="'+m.medium_photo_url+'">\n' +
                '              </div>\n' +
                '            </div>\n' +
                '            <div class="product-block-one-cintent">\n' +
                '              <h4 class="fs_15"><a>'+ m.description +' </a></h4>\n' +
                '              <div class="rating">\n' +
                '                <i class="fas fa-medal"></i>\n' +
                '                <span>Garantía: '+m.warranty_months+' </span>\n' +
                '              </div>\n' +
                '              <div class="price-container">\n' +
                '                <div class="price fs_15 fw_medium">'+m.price+'<span>'+m.price_iva+'</span></div>\n' +
                '              </div>\n' +
                '            </div>\n' +
                '          </div>\n' +
                '        </div>\n'
            modelsHtml = modelsHtml + model
        })
        resultModels.innerHTML = modelsHtml
    } else if(!isNullOrUndef(bcis) && 'undefined' !== bcis && 'null' !== bcis  && 'Undefined or Null' !== bcis ) {
        target.innerHTML = 'No se encontraron resultados para BCI: ' + bcis
    }
}

function getCustomer()  {
    let phone_number = $('#warranty_phone_number').val()
    if (!phone_number || phone_number.length < 10) {
        return $.Deferred().resolve().promise();
    }
    $('#warranty_first_name').val()
    $('#warranty_last_name').val()
    $('#warranty_email').val()
    let path = '/search/customer/' + $('#warranty_phone_number').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                if (data.customer) {
                    $('#warranty_phone_number').val(phone_number)
                    $('#warranty_first_name').val(data.customer.first_name)
                    $('#warranty_last_name').val(data.customer.last_name)
                    $('#warranty_email').val(data.customer.email)
                }
            } else {
                console.error('Something goes wrong while getting '+phone_number)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}

const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id','vehicle_years_id','vehicle_makes_id','vehicle_models_id','vehicle_engines_id']
function setupLanding() {
    // var $select2Element = $('.select2');
    // $('.select2').select2({
    //     // tags: true,
    //     tokenSeparators: [',', ' '],
    //     // allowClear: true,
    //     theme: "classic",
    //     width: 'resolve'
    // });

    // // // Add the 'nice-select' class to the Select2 container
    // $select2Element.data('select2').$container.addClass('nice-select');

    const form = document.getElementById("home-landing");
    if (form) {
        // console.log('warranties turbolinks loaded.')
        // Clear previous listeners
        clearSelect2(...select2Ids)

        initVehicleSearch()
        // checkVehicleSearch(true)

        // let vehicle_years = document.getElementById('vehicle_years_id')
        $(document)
            // .on('select2:select', '#vehicle_years_id', getVehicleMakes)
            // .on('select2:select', '#vehicle_makes_id', getVehicleModels)
            // .on('select2:select', '#vehicle_models_id', getVehicleEngines)
            // .on('select2:select', '#vehicle_engines_id', setVehicleProduct)
            .on('change', '#warranty_phone_number', getCustomer)
            .on('change', '#warranty_fleet', setWarranty)
    }
}

function destroyLanding() {
    const form = document.getElementById("home-landing");
    if (form) {
        // console.log("Cleanup home-landing...")
        // document.removeEventListener("turbolinks:load", setupLanding);
        // document.removeEventListener('turbolinks:before-cache', destroyLanding)

        $(document)
            // .off('select2:select', '#vehicle_years_id', getVehicleMakes)
            // .off('select2:select', '#vehicle_makes_id', getVehicleModels)
            // .off('select2:select', '#vehicle_models_id', getVehicleEngines)
            // .off('select2:select', '#vehicle_engines_id', setVehicleProduct)
            .off('change', '#warranty_phone_number', getCustomer)

        $('.selectpicker').each(function() {
            if ($(this).data('select2')) {
                $(this).select2('destroy');
            }
        });
    }
}
document.addEventListener("turbolinks:load", setupLanding);
// document.addEventListener('turbolinks:before-cache', destroyLanding);
window.addEventListener('beforeunload', (event) => {
    destroyLanding();
});

// window.checkVehicleSearch = checkVehicleSearch;
// window.getVehicleMakes = getVehicleMakes;
// window.getVehicleModels = getVehicleModels;
// window.getVehicleEngines = getVehicleEngines;
// window.setVehicleProduct = setVehicleProduct;
